@import '~style-sheet-helpers/core.less';

.checklist-row {
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 10px;

  .pill {
    margin-left: 10px;
  }
}

.normal-content {
  height: 42px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  width: 100%;
}

.third-party-logo {
  height: 20px;
  width: 20px;
  align-self: center;
}

.message {
  .truncate();
  width: calc(100% - 35px);
  margin-left: 5px;
  line-height: 30px;
}
